// extracted by mini-css-extract-plugin
export default {"cls1":"CollapsedActivityPreview-cls1_W92","cls2":"CollapsedActivityPreview-cls2___z CollapsedActivityPreview-cls1_W92"};